import { Routes } from '@angular/router';
import { isLoginGuard } from '../sdk/services/guards/islogin.service';
import { redirectLoginGuard } from '../sdk/services/guards/redirectlogin.service';
import { isAdminLoginGuard } from '../sdk/services/guards/isAdminLogin.service';
import { isNotAdminLoginGuard } from '../sdk/services/guards/isNotAdminLogin.service';

import { HomeLayoutComponent } from './layout/home-layout/home-layout.component';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { ListingsLayoutComponent } from './layout/listings-layout/listings-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeLayoutComponent,
    children: [
      {
        path: 'falaya-feeling',
        loadChildren: () =>
          import('./falayafeeling/falaya-feeling.module').then((m) => m.FalayaFeelingModule),
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./../new-home-module/new-home-module.module').then((m) => m.NewHomeModuleModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./../new-home-module/new-home-module.module').then((m) => m.NewHomeModuleModule),
      },
      {
        path: 'home',
        redirectTo: '/',
      },
      {
        path: 'buy',
        loadChildren: () =>
          import('./buymodule/buy.module').then((m) => m.BuyModule),
      },
      {
        path: 'sell',
        loadChildren: () =>
          import('./sellmodule/sell.module').then((m) => m.SellModule),
      },
      {
        path: 'features',
        loadChildren: () =>
          import('./falaya-features/falaya-features.module').then((m) => m.FalayaFeaturesModule),
      },
      {
        path: 'meeting-booked',
        loadChildren: () =>
          import('./calendly-confirmation/calendly-confirmation.module').then((m) => m.CalendlyConfirmationModule),
      },
      {
        path: 'browse/homes/:county',
        loadChildren: () =>
          import('./sharedmodule/components/browse-homes/browse-homes.module').then((m) => m.BrowseHomesModule),
      },
      {
        path: 'pricing',
        loadChildren: () =>
          import('./sharedmodule/components/pricing/pricing.module').then((m) => m.PricingModule),
      },
      {
        path: 'comparison',
        loadChildren: () =>
          import('./comparison/comparison.module').then((m) => m.ComparisonModule),
      },
      {
        path: 'about-us',
        loadChildren: () =>
          import('./aboutus/aboutus.module').then((m) => m.AboutUsModule),
      },
      {
        path: 'terms',
        loadChildren: () =>
          import('./terms/terms.module').then((m) => m.TermsModule),
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('./contactus/contactus.module').then((m) => m.ContactusModule),
      },
    ],
  },
  {
    path: 'routing/module',
    loadChildren: () =>
      import('./redirection-module/redirection-module.module').then((m) => m.RedirectionModule),
  },
  {
    path: 'templates',
    loadChildren: () =>
      import('./templates-for-ai/templates-for-ai.module').then((m) => m.TemplatesForAIModule),
  },
  {
    path: 'guide',
    loadChildren: () =>
      import('./sellers-guide/sellers-guide.module').then((m) => m.SellersGuideModule),
  },
  {
    path: 'flat-fee-mls-listings',
    loadChildren: () =>
      import('./sharedmodule/components/flat-fee-module/flatfeemodule.module').then((m) => m.FlatFeeModule),
  },
  {
    path: '',
    component: ListingsLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/listings',
        pathMatch: 'full',
      },
      {
        path: 'listings',
        loadChildren: () =>
          import('./listingsmodule/listings.module').then((m) => m.ListingsModule),
      },
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
      },
      {
        canActivate: [redirectLoginGuard],
        path: 'login',
        loadChildren: () =>
          import('./login-shared/login-shared.module').then((m) => m.LoginSharedModule),
      },
      {
        canActivate: [redirectLoginGuard],
        path: 'signup',
        loadChildren: () =>
          import('./signup-shared/signup-shared.module').then((m) => m.SignupSharedModule),
      },
      {
        path: 'forgot',
        canActivate: [redirectLoginGuard],
        loadChildren: () =>
          import('./login/forgot/forgot.module').then((m) => m.ForgotModule),
      },
      {
        path: 'password-recovery',
        loadChildren: () =>
          import('./login/password-recovery/password-recovery.module').then((m) => m.PasswordRecoveryModule),
      },
    ],
  },
  {
    path: 'listing',
    redirectTo: '/listing-payment',
    pathMatch: 'full',
  },
  {
    path: 'listing-payment',
    loadChildren: () =>
      import('../app/sharedmodule/components/listing-payment/listing-payment.module').then(
        (m) => m.ListingPaymentComponentModule
      ),
    canActivate: [isLoginGuard],
  },
  {
    path: 'add-valuation',
    loadChildren: () =>
      import('../app/sharedmodule/components/add-valuation/add-valuationcomponent.module').then(
        (m) => m.AddValuationcomponentModule
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./../dashboardmodule/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [isLoginGuard, isNotAdminLoginGuard],
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./../adminmodule/admin.module').then((m) => m.AdminModule),
    canActivate: [isLoginGuard, isAdminLoginGuard],
  },
  {
    path: 'browse',
    loadChildren: () =>
      import('./browsemodule/browse.module').then((m) => m.BrowseModule),
  },
  {
    path: 'rent',
    loadChildren: () =>
      import('./rentmodule/rent.module').then((m) => m.RentModule),
  },
  {
    path: 'video',
    loadChildren: () =>
      import('./videomodule/video.module').then((m) => m.VideoModule),
  },
  {
    path: 'offers/hello-sign-mobile-web-view/:id/:state',
    loadChildren: () =>
      import('./sharedmodule/components/hello-sign-web-view/hello-sign-web-view.module').then(
        (m) => m.HelloSignWebViewModule
      ),
    canActivate: [isLoginGuard, isNotAdminLoginGuard],
  },
  {
    path: ':state/:city/homes-for-sale',
    component: ListingsLayoutComponent,
    loadChildren: () =>
      import('./Alllistingsmodule/listings.module').then((m) => m.ListingsModule),
  },
  {
    path: 'mobilefaqs',
    loadChildren: () =>
      import('./sharedmodule/components/faqs/faqs.module').then((m) => m.FaqsModule),
  },
  {
    path: '404',
    loadChildren: () =>
      import('./not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: 'sell-faster-save-thousands',
    loadChildren: () =>
      import('./landingpage/landingPage.module').then((m) => m.LandingPageModule),
  },
  {
    path: 'free-valuation',
    loadChildren: () =>
      import('./free-valuation/free-valuation.module').then((m) => m.FreeValuationModule),
  },
  {
    path: 'seller-consultation',
    loadChildren: () =>
      import('./seller-consultation/seller-consultation.module').then((m) => m.SellerConsultationModule),
  },
  {
    path: 'disclosure/hellosign/:id',
    loadChildren: () =>
      import('./sharedmodule/components/hello-sign-signature-component/hello-sign-signature-component.module').then(
        (m) => m.HelloSignSignatureComponentModule
      ),
  },
  {
    path: 'disclosure/success',
    loadChildren: () =>
      import('./sharedmodule/components/disclosure-signature-success/disclosure-signature-success.module').then(
        (m) => m.DisclosureSignatureSuccessModule
      ),
  },
  { path: '**', redirectTo: '/404' },
];
